export default function Experience(){
    return (
        <section id="experience" className="experience">
            <h1>WORK EXPERIENCE</h1> 
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h3>AppLever Tech Pvt Ltd | Internship</h3>
                        <div className="flex">
                            <p>Bengaluru</p>
                            <p>Aug 2023 - Feb 2024</p>
                        </div>
                        <div>
                            <ul>
                                <li>Collaborated with teams to create responsive web designs using HTML, CSS, Bootstrap and React.js ensuring compatibility on all devices.</li>
                                <li>Crafted engaging user interfaces and dynamic web applications utilizing JavaScript.</li>
                                <li>Designed and implemented responsive layouts and animations using CSS3 and Bootstrap framework.</li>
                                <li>Integrated APIs to enhance web app functionality and user experience.</li>
                                <li>Customized Wix websites for clients, optimizing them with JavaScript for visual appeal and functionality.</li>
                                <li>Conducted code reviews, offering feedback to improve quality and maintain best practices.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src="images/work.jpg" alt="work"/>
                    </div>
                </div>
            </div><br/>
        </section>
    );
}